var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"need-know"},[_c('div',{staticClass:"knowBg"}),_c('button',{staticClass:"start",on:{"click":_vm.toTest}},[_vm._v("下一步")])])}
var staticRenderFns = []

export { render, staticRenderFns }